module.exports = __webpack_public_path__ + "img/u450.8ab108d1.svg";